import React from 'react';
import ReactDOM from 'react-dom';
import {
  TagButton,
  TagText,
  TagList,
  TagProgressDonut,
  TagAvatar,
  TagCombobox,
  //TagPill,
  TagPills,
  TagNav,
  TagNavSimple,
  TagNavSimpleGroup,
  TagNavSimpleItem,
  TagAlert,
  TagAppHeader,
  TagBadge,
  TagBar,
  TagCardProfile,
  TagCarousel,
  TagCarouselSlide,
  TagLink,
  TagCard,
  TagStat,
  TagStats,
  TagCheckbox,
  TagColour,
  TagModal,
  //TagColumnPicker,
  TagEditField,
  TagConfirm,
  TagDatePicker,
  TagSearch,
  TagTabs,
  TagTable,
  TagTooltip,
  TagField,
  TagAccessLogo,
  TagFilePicker,
  TagSearchbox,
  TagProgressIndeterminate,
  TagPopover,
  TagWizard,
  TagWizardStep,
  TagForm,
  TagFormGroup,
  TagSlider,
  TagTopNavbar,
  //TagGraphql,
  TagPager,
  TagMessage,
  TagIcon,
  TagToast,
  TagToggle,
  TagMenu,
  TagHttp,
  //TagValidation,
  TagTabHeaders,
  TagTabHeader,
  TagTabContent,
  TagWizardVertical,
  TagWizardVerticalSteps,
  TagWizardVerticalStep,
  TagWizardVerticalStepIndicator,
  TagWizardVerticalContent,
} from '@tag/tag-components-react-v2';

import {
  TagAlert as Tag3Alert,
  TagAppHeader as Tag3AppHeader,
  TagAppHeaderOption as Tag3AppHeaderOption,
  TagAppHeaderOptionSeparator as Tag3AppHeaderOptionSeparator,
  TagAutocomplete as Tag3Autocomplete,
  TagAvatar as Tag3Avatar,
  TagBadge as Tag3Badge,
  TagButton as Tag3Button,
  TagCard as Tag3Card,
  TagCarousel as Tag3Carousel,
  TagCarouselSlide as Tag3CarouselSlide,
  TagCheckbox as Tag3Checkbox,
  TagClickable as Tag3Clickable,
  TagCloseableBox as Tag3CloseableBox,
  TagColour as Tag3Colour,
  TagColourOption as Tag3ColourOption,
  TagCustomColourPicker as Tag3CustomColourPicker,
  TagDatePicker as Tag3DatePicker,
  TagDatePickerBox as Tag3DatePickerBox,
  TagMobileFanMenu as Tag3MobileFanMenu,
  TagMobileFanMenuItem as Tag3MobileFanMenuItem,
  TagFilePicker as Tag3FilePicker,
  TagFilePickerButton as Tag3FilePickerButton,
  TagFilePickerDragdrop as Tag3FilePickerDragdrop,
  TagFormat as Tag3Format,
  TagH1 as Tag3H1,
  TagH2 as Tag3H2,
  TagH3 as Tag3H3,
  TagH4 as Tag3H4,
  TagH5 as Tag3H5,
  TagIcon as Tag3Icon,
  TagIconCustom as Tag3IconCustom,
  TagIconSvg as Tag3IconSvg,
  TagInput as Tag3Input,
  TagTextarea as Tag3Textarea,
  TagKpi as Tag3Kpi,
  TagKpiLabel as Tag3KpiLabel,
  TagLabel as Tag3Label,
  TagListItem as Tag3ListItem,
  TagMenu as Tag3Menu,
  TagMenuButton as Tag3MenuButton,
  TagMenuItem as Tag3MenuItem,
  TagMobileNav as Tag3MobileNav,
  TagMobileNavOption as Tag3MobileNavOption,
  TagP as Tag3P,
  TagPill as Tag3Pill,
  TagPills as Tag3Pills,
  TagPopover as Tag3Popover,
  TagRadioButton as Tag3RadioButton,
  TagRadioButtons as Tag3RadioButtons,
  TagRoundButton as Tag3RoundButton,
  TagRoundedBackground as Tag3RoundedBackground,
  TagSegmentedMenuButton as Tag3SegmentedMenuButton,
  TagSimpleButton as Tag3SimpleButton,
  TagTertiaryButton as Tag3TertiaryButton,
  TagSimpleList as Tag3SimpleList,
  TagSlider as Tag3Slider,
  TagSpan as Tag3Span,
  TagSquareButton as Tag3SquareButton,
  TagStat as Tag3Stat,
  TagStats as Tag3Stats,
  TagStatsData as Tag3StatsData,
  TagSwitch as Tag3Switch,
  TagText as Tag3Text,
  TagTextFeature as Tag3TextFeature,
  TagTextSmall as Tag3TextSmall,
  TagToast as Tag3Toast,
  TagValidationAlert as Tag3ValidationAlert,
  TagValidationAlertInline as Tag3ValidationAlertInline,
  TagValidator as Tag3Validator,
  TagToggle as Tag3Toggle,
  TagToggleOption as Tag3ToggleOption,
  TagTooltip as Tag3Tooltip,
  TagWizardVertical as Tag3WizardVertical,
  TagWizardVerticalSteps as Tag3WizardVerticalSteps,
  TagWizardVerticalStep as Tag3WizardVerticalStep,
  TagWizardVerticalStepIndicator as Tag3WizardVerticalStepIndicator,
  TagWizardVerticalContent as Tag3WizardVerticalContent,
  TagSimpleModal as Tag3SimpleModal,
  TagMobileAlert,
  TagMobileDateTimeInput,
  TagMobileDropDown,
  TagMobileHeader,
  TagMobileModal as Tag3MobileModal,
  TagMobileModalHeader as Tag3MobileModalHeader,
  TagMobileSwipeout,
  TagMobileSideMenu,
  TagMobileSideMenuOption,
  TagMobileSideMenuList,
  TagMobileSideMenuListOption,
  TagMobileSliderPopover,
  TagMobileTimeInput,
  TagMobileToast,
  TagMobileVerticalSliderPanel as Tag3MobileVerticalSliderPanel,
  TagProgressDonut as Tag3ProgressDonut,
  TagSearchbox as Tag3Searchbox,
  TagPager as Tag3Pager,
  TagTabHeaders as Tag3TabHeaders,
  TagTabHeader as Tag3TabHeader,
  TagTabContent as Tag3TabContent,
  TagTable as Tag3Table,
  TagDropDown as Tag3DropDown,
  TagColumnPicker as Tag3ColumnPicker,
  TagChart as Tag3Chart,
  TagProgressIndeterminate as Tag3ProgressIndeterminate,
  TagSideNav as Tag3SideNav,
  TagSideNavHeader as Tag3SideNavHeader,
  TagSideNavBody as Tag3SideNavBody,
  TagSideNavPanel as Tag3SideNavPanel,
  TagSideNavItem as Tag3SideNavItem,
  TagSkeleton,
  // TagDropDownFlex as Tag3DropDownFlex,
  TagLinkButton as Tag3LinkButton,
  TagLink as Tag3Link,
} from '@tag/tag-components-react-v3';

// tag-components can integrate with Formik and RHF
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';

// these are the references that the code snipets will use
export function defineGlobals() {
  window.React = React;
  window.ReactDOM = ReactDOM;
  window.Formik = Formik;
  window.Form = Form;
  window.Yup = Yup;
  window.useForm = useForm;
  window.TagAccessLogo = TagAccessLogo;
  window.TagAlert = TagAlert;
  window.TagAppHeader = TagAppHeader;
  window.TagAvatar = TagAvatar;
  window.TagBadge = TagBadge;
  window.TagBar = TagBar;
  window.TagButton = TagButton;
  window.TagCard = TagCard;
  window.TagCardProfile = TagCardProfile;
  window.TagCarousel = TagCarousel;
  window.TagCarouselSlide = TagCarouselSlide;
  window.TagCheckbox = TagCheckbox;
  window.TagColour = TagColour;
  //window.TagColumnPicker = TagColumnPicker;
  window.TagCombobox = TagCombobox;
  window.TagConfirm = TagConfirm;
  window.TagDatePicker = TagDatePicker;
  window.TagEditField = TagEditField;
  window.TagField = TagField;
  window.TagFilePicker = TagFilePicker;
  window.TagForm = TagForm;
  window.TagFormGroup = TagFormGroup;
  //window.TagGraphql = TagGraphql;
  window.TagHttp = TagHttp;
  window.TagIcon = TagIcon;
  window.TagLink = TagLink;
  window.TagList = TagList;
  window.TagMenu = TagMenu;
  window.TagMessage = TagMessage;
  window.TagModal = TagModal;
  window.TagNav = TagNav;
  window.TagNavSimple = TagNavSimple;
  window.TagNavSimpleGroup = TagNavSimpleGroup;
  window.TagNavSimpleItem = TagNavSimpleItem;
  window.TagPager = TagPager;
  //window.TagPill = TagPill;
  window.TagPills = TagPills;
  window.TagPopover = TagPopover;
  window.TagProgressDonut = TagProgressDonut;
  window.TagProgressIndeterminate = TagProgressIndeterminate;
  window.TagSearch = TagSearch;
  window.TagSearchbox = TagSearchbox;
  window.TagSlider = TagSlider;
  window.TagStat = TagStat;
  window.TagStats = TagStats;
  window.TagTable = TagTable;
  window.TagTabs = TagTabs;
  window.TagText = TagText;
  window.TagToggle = TagToggle;
  window.TagTooltip = TagTooltip;
  window.TagTopNavbar = TagTopNavbar;
  //window.TagValidation = TagValidation;
  window.TagWizard = TagWizard;
  window.TagWizardStep = TagWizardStep;
  window.TagToast = TagToast;
  window.TagTabHeaders = TagTabHeaders;
  window.TagTabHeader = TagTabHeader;
  window.TagTabContent = TagTabContent;
  window.TagWizardVertical = TagWizardVertical;
  window.TagWizardVerticalSteps = TagWizardVerticalSteps;
  window.TagWizardVerticalStep = TagWizardVerticalStep;
  window.TagWizardVerticalStepIndicator = TagWizardVerticalStepIndicator;
  window.TagWizardVerticalContent = TagWizardVerticalContent;

  window.Tag3Alert = Tag3Alert;
  window.Tag3AppHeader = Tag3AppHeader;
  window.Tag3AppHeaderOption = Tag3AppHeaderOption;
  window.Tag3AppHeaderOptionSeparator = Tag3AppHeaderOptionSeparator;
  window.Tag3Autocomplete = Tag3Autocomplete;
  window.Tag3Avatar = Tag3Avatar;
  window.Tag3Badge = Tag3Badge;
  window.Tag3Button = Tag3Button;
  window.Tag3Card = Tag3Card;
  window.Tag3Carousel = Tag3Carousel;
  window.Tag3CarouselSlide = Tag3CarouselSlide;
  window.Tag3Checkbox = Tag3Checkbox;
  window.Tag3Clickable = Tag3Clickable;
  window.Tag3CloseableBox = Tag3CloseableBox;
  window.Tag3Colour = Tag3Colour;
  window.Tag3ColourOption = Tag3ColourOption;
  window.Tag3CustomColourPicker = Tag3CustomColourPicker;
  window.Tag3DatePicker = Tag3DatePicker;
  window.Tag3DatePickerBox = Tag3DatePickerBox;
  window.Tag3MobileFanMenu = Tag3MobileFanMenu;
  window.Tag3MobileFanMenuItem = Tag3MobileFanMenuItem;
  window.Tag3FilePicker = Tag3FilePicker;
  window.Tag3FilePickerButton = Tag3FilePickerButton;
  window.Tag3FilePickerDragdrop = Tag3FilePickerDragdrop;
  window.Tag3Format = Tag3Format;
  window.Tag3H1 = Tag3H1;
  window.Tag3H2 = Tag3H2;
  window.Tag3H3 = Tag3H3;
  window.Tag3H4 = Tag3H4;
  window.Tag3H5 = Tag3H5;
  window.Tag3Icon = Tag3Icon;
  window.Tag3IconCustom = Tag3IconCustom;
  window.Tag3IconSvg = Tag3IconSvg;
  window.Tag3Input = Tag3Input;
  window.Tag3Textarea = Tag3Textarea;
  window.Tag3Kpi = Tag3Kpi;
  window.Tag3KpiLabel = Tag3KpiLabel;
  window.Tag3Label = Tag3Label;
  window.Tag3ListItem = Tag3ListItem;
  window.Tag3Menu = Tag3Menu;
  window.Tag3MenuButton = Tag3MenuButton;
  window.Tag3MenuItem = Tag3MenuItem;
  window.Tag3MobileNav = Tag3MobileNav;
  window.Tag3MobileNavOption = Tag3MobileNavOption;
  window.Tag3P = Tag3P;
  window.Tag3Pill = Tag3Pill;
  window.Tag3Pills = Tag3Pills;
  window.Tag3Popover = Tag3Popover;
  window.Tag3RadioButton = Tag3RadioButton;
  window.Tag3RadioButtons = Tag3RadioButtons;
  window.Tag3RoundButton = Tag3RoundButton;
  window.Tag3RoundedBackground = Tag3RoundedBackground;
  window.Tag3SegmentedMenuButton = Tag3SegmentedMenuButton;
  window.Tag3SimpleButton = Tag3SimpleButton;
  window.Tag3TertiaryButton = Tag3TertiaryButton;
  window.Tag3SimpleList = Tag3SimpleList;
  window.Tag3Slider = Tag3Slider;
  window.Tag3Span = Tag3Span;
  window.Tag3SquareButton = Tag3SquareButton;
  window.Tag3Stat = Tag3Stat;
  window.Tag3Stats = Tag3Stats;
  window.Tag3StatsData = Tag3StatsData;
  window.Tag3Switch = Tag3Switch;
  window.Tag3Text = Tag3Text;
  window.Tag3TextFeature = Tag3TextFeature;
  window.Tag3TextSmall = Tag3TextSmall;
  window.Tag3Toast = Tag3Toast;
  window.Tag3ValidationAlert = Tag3ValidationAlert;
  window.Tag3ValidationAlertInline = Tag3ValidationAlertInline;
  window.Tag3Validator = Tag3Validator;
  window.Tag3Toggle = Tag3Toggle;
  window.Tag3ToggleOption = Tag3ToggleOption;
  window.Tag3Tooltip = Tag3Tooltip;
  window.Tag3WizardVertical = Tag3WizardVertical;
  window.Tag3WizardVerticalSteps = Tag3WizardVerticalSteps;
  window.Tag3WizardVerticalStep = Tag3WizardVerticalStep;
  window.Tag3WizardVerticalStepIndicator = Tag3WizardVerticalStepIndicator;
  window.Tag3WizardVerticalContent = Tag3WizardVerticalContent;
  window.Tag3SimpleModal = Tag3SimpleModal;
  window.TagMobileAlert = TagMobileAlert;
  window.TagMobileDateTimeInput = TagMobileDateTimeInput;
  window.TagMobileDropDown = TagMobileDropDown;
  window.TagMobileHeader = TagMobileHeader;
  window.TagMobileTimeInput = TagMobileTimeInput;
  window.TagMobileToast = TagMobileToast;
  window.Tag3MobileModal = Tag3MobileModal;
  window.Tag3MobileModalHeader = Tag3MobileModalHeader;
  window.TagMobileSideMenu = TagMobileSideMenu;
  window.TagMobileSideMenuOption = TagMobileSideMenuOption;
  window.TagMobileSideMenuList = TagMobileSideMenuList;
  window.TagMobileSideMenuListOption = TagMobileSideMenuListOption;
  window.TagMobileSliderPopover = TagMobileSliderPopover;
  window.Tag3MobileVerticalSliderPanel = Tag3MobileVerticalSliderPanel;
  window.Tag3ProgressDonut = Tag3ProgressDonut;
  window.Tag3Searchbox = Tag3Searchbox;
  window.Tag3Pager = Tag3Pager;
  window.Tag3TabHeaders = Tag3TabHeaders;
  window.Tag3TabHeader = Tag3TabHeader;
  window.Tag3TabContent = Tag3TabContent;
  window.Tag3Table = Tag3Table;
  window.Tag3DropDown = Tag3DropDown;
  window.Tag3ColumnPicker = Tag3ColumnPicker;
  window.Tag3Chart = Tag3Chart;
  window.Tag3ProgressIndeterminate = Tag3ProgressIndeterminate;
  window.TagMobileSwipeout = TagMobileSwipeout;
  window.Tag3SideNav = Tag3SideNav;
  window.Tag3SideNavHeader = Tag3SideNavHeader;
  window.Tag3SideNavBody = Tag3SideNavBody;
  window.Tag3SideNavPanel = Tag3SideNavPanel;
  window.Tag3SideNavItem = Tag3SideNavItem;
  window.TagSkeleton = TagSkeleton;
  // window.Tag3DropDownFlex = Tag3DropDownFlex;
  window.Tag3LinkButton = Tag3LinkButton;
  window.Tag3Link = Tag3Link;
}
